/** Spanish for the stock area (docs/conventions/i18n.md). Keys are the English copy, verbatim. */
export const esStock: Readonly<Record<string, string>> = {
  'All in order': 'Todo en orden',
  'All in order.': 'Todo en orden.',
  '{count} late': '{count} con retraso',
  '{count} due soon': '{count} para estos días',
  'Nothing is late or due soon, nothing is below its minimum and the shopping list is empty.':
    'Nada va con retraso ni vence estos días, nada está por debajo del mínimo y la lista de la compra está vacía.',
  '{count} product': '{count} producto',
  '{count} products': '{count} productos',
  '{count} to buy': '{count} por comprar',
  // Inventory
  Inventory: 'Inventario',
  '{count} product · {total} invested': '{count} producto · {total} invertidos',
  '{count} products · {total} invested': '{count} productos · {total} invertidos',
  Add: 'Añadir',
  'The inventory is empty': 'El inventario está vacío',
  'Add what you already have: water, food, first aid kit, torches… with its price and expiry date.':
    'Añade lo que ya tenéis: agua, comida, botiquín, linternas… con su precio y su caducidad.',
  'Add the first product': 'Añadir el primer producto',
  'Nothing matches the filter.': 'Nada coincide con el filtro.',
  'Search by name, brand, place…': 'Buscar por nombre, marca, lugar…',
  Category: 'Categoría',
  'All categories': 'Todas las categorías',
  Location: 'Ubicación',
  'All locations': 'Todas las ubicaciones',
  Sort: 'Ordenar',
  Filter: 'Filtro',
  All: 'Todo',
  'Expiring soon': 'Caduca pronto',
  Expired: 'Caducado',
  'Low stock': 'Stock bajo',
  'By due date': 'Por vencimiento',
  'By name': 'Por nombre',
  'By location': 'Por ubicación',
  pack: 'paquete',
  box: 'caja',
  'Product saved': 'Producto guardado',
  'Product added': 'Producto añadido',
  'New product': 'Nuevo producto',
  Product: 'Producto',
  Name: 'Nombre',
  'e.g. Mineral water 5 L': 'p. ej. Agua mineral 5 L',
  Brand: 'Marca',
  Quantity: 'Cantidad',
  Unit: 'Unidad',
  Minimum: 'Mínimo',
  'Warns below this': 'Avisa si baja de aquí',
  'Backpack, pantry, car…': 'Mochila, despensa, coche…',
  Tags: 'Etiquetas',
  Purchase: 'Compra',
  'Price paid': 'Precio pagado',
  'For the whole quantity': 'Por toda la cantidad',
  'Purchase date': 'Fecha de compra',
  Store: 'Tienda',
  'Expiry and replacement': 'Caducidad y reposición',
  'Expires on': 'Caduca el',
  'Unsafe after this date': 'No consumir después',
  'Best before': 'Consumo preferente',
  'Quality, not safety': 'Calidad, no seguridad',
  'Product page': 'Ficha del producto',
  'Replace or check on': 'Reponer o revisar el',
  'Batteries, water, rotation…': 'Pilas, agua, rotación…',
  'Shelf life (months)': 'Vida útil (meses)',
  'Counted from the purchase date': 'Cuenta desde la fecha de compra',
  'Until {date}, counting from the purchase': 'Hasta el {date}, contando desde la compra',
  Medicine: 'Medicamento',
  'Active ingredient': 'Principio activo',
  'e.g. Paracetamol': 'p. ej. Paracetamol',
  Dose: 'Dosis',
  'e.g. 1 g every 8 h': 'p. ej. 1 g cada 8 h',
  'Notes and files': 'Notas y archivos',
  Notes: 'Notas',

  // Shopping
  Shopping: 'Compras',
  'What is left to buy and what it will cost.': 'Lo que falta por comprar y cuánto costará.',
  'All stores': 'Todas las tiendas',
  'No store': 'Sin tienda',
  'To buy': 'Por comprar',
  Bought: 'Compradas',
  Discarded: 'Descartadas',
  'Nothing pending': 'No hay nada pendiente',
  'Write down what you are missing with a price estimate to know what completing the kit costs.':
    'Apunta lo que os falta con una estimación de precio para saber cuánto cuesta completar el kit.',
  'Add to the list': 'Añadir a la lista',
  'Nothing here.': 'Nada por aquí.',
  'Pending estimate': 'Estimado pendiente',
  '{count} without an estimate': '{count} sin estimar',
  '{count} item': '{count} artículo',
  '{count} items': '{count} artículos',
  'High priority': 'Prioridad alta',
  'Medium and low': 'Media y baja',
  'Already spent': 'Ya gastado',
  'On what was bought from the list': 'En lo comprado de la lista',
  'bought on {date}': 'comprado el {date}',
  'Open link': 'Abrir enlace',
  'Mark {name} as bought': 'Marcar {name} como comprado',
  'Back to pending': 'Volver a pendientes',
  'Invalid amount': 'Importe no válido',
  'Bought and added to the inventory': 'Comprado y añadido al inventario',
  'Marked as bought': 'Marcado como comprado',
  'Bought: {name}': 'Comprado: {name}',
  'Write down what it really cost to sharpen the next estimates.':
    'Apunta lo que costó de verdad para afinar las próximas estimaciones.',
  'Actual price': 'Precio real',
  Date: 'Fecha',
  'Add to the inventory': 'Añadir al inventario',
  'Creates the product with the quantity, the store and the price':
    'Crea el producto con la cantidad, la tienda y el precio',
  Cancel: 'Cancelar',
  Confirm: 'Confirmar',
  Saved: 'Guardado',
  'Added to the list': 'Añadido a la lista',
  'Entry discarded': 'Descartado',
  Discard: 'Descartar',
  What: 'Qué',
  'e.g. Portable water filter': 'p. ej. Filtro de agua portátil',
  Priority: 'Prioridad',
  'Cost and where': 'Coste y dónde',
  'Estimated price': 'Precio estimado',
  'Needed by': 'Para cuándo',
  Link: 'Enlace',
  'Bought on {date} for {price}.': 'Comprado el {date} por {price}.',

  // Dashboard
  'Hi, {name}': 'Hola, {name}',
  Dashboard: 'Panel',
  '{count} low on stock': '{count} con stock bajo',
  'Needs attention': 'Necesita atención',
  'Shopping list': 'Lista de la compra',
  '{quantity} left, minimum {minimum}': 'Hay {quantity}, mínimo {minimum}',
  Restock: 'Reponer',
  'See all': 'Ver todo',
  'By category': 'Por categoría',
  'You have nothing in this category yet': 'Aún no tenéis nada de esta categoría',
  Products: 'Productos',
  'Tasks to do': 'Tareas abiertas',
  Documents: 'Documentos',
};
